/**
 * For a scroll area next to another one (reservation dialog, full profile): a thin scrollbar whose thumb shows only
 * while the pointer is over the area, and whose room stays reserved, so the content does not jump once it starts to
 * scroll. That applies to classic scrollbars (Windows, a Mac with a mouse); macOS overlay scrollbars keep floating and
 * take no room.
 * No ::-webkit-scrollbar rules on purpose: in Safari they would turn the Mac's overlay scrollbars into permanent ones,
 * and Chrome does not repaint them when the hover ends.
 */
export var thinScrollbarSx = {
    scrollbarGutter: 'stable',
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&:hover': {
        scrollbarColor: 'rgba(15, 23, 42, 0.2) transparent',
    },
};
